<template>
  <div id="personal">
    <div class="page_tit_box">
      <div class="center_content u-flex">
        <div>
          <img class="tit_img" src="../assets/images/index_icon1.png" alt="" />
        </div>
        <div>首页>个人中心</div>
      </div>
    </div>

    <div class="cert_center">
        <el-container>
            <el-aside width="200px">
                <div class="left_nav">
                    <div class="nav_tit u-flex u-row-between">
                        <div><img src="../assets/images/grzx.png" alt=""></div>
                        <div class="nav_line"></div>
                    </div>
                    <el-menu class="nav_menu" :default-active="activeIndex" active-text-color="#303643"
                    @select="menuChange">
                        <el-menu-item index="1">
                            <img class="nav_icon" src="../assets/images/left_nav_icon1.png" alt="">
                            <span slot="title">发票信息</span>
                        </el-menu-item>
                      
                        <el-menu-item index="2">
                            <img class="nav_icon" src="../assets/images/left_nav_icon1.png" alt="">
                            <span slot="title">保函订单</span>
                        </el-menu-item>
                    </el-menu>
                </div>
            </el-aside>
            <el-main class="center_main">
                <invoice v-show="activeIndex=='1'"/>
                <orderList v-show="activeIndex=='2'"/>
            </el-main>
        </el-container>
    </div>
    
  </div>
</template>
<script>
import invoice from "@/components/invoice"
import orderList from "@/components/orderList"

export default {
  name: "",
  components: {
      invoice,
      orderList
  },
  data() {
    return {
        activeIndex:"1",
    };
  },
  mounted() {
    if(this.$route.query.activeIndex){
      this.activeIndex=this.$route.query.activeIndex
    }
  },
  methods: {
      menuChange(index){
          this.activeIndex=index
      },
     
  },
};
</script>
<style lang='scss' scoped>
#personal {
  .page_tit_box {
    background: #e2e4ee;
    padding: 20px 0;
    font-size: 14px;
  }
  .center_content {
    width: 1500px;
    margin: 0 auto;
    .tit_img {
      width: 14px;
      height: 18px;
      margin-right: 16px;
    }
  }
  .cert_center {
    width: 1500px;
    margin: 20px auto;
    .left_nav{
        background-color: #fff;
        height: 100%;
        overflow: hidden;
        margin-right: 10px;
        .nav_tit{
            margin-left: 26px;
            margin-top: 38px;
        }
        .nav_line{
            width: 57px;
            height: 1px;
            background-color: #303643;
        }
        .nav_menu{
            border: none;
            margin-top: 42px;
            .el-menu-item{
                height: 50px;
                line-height: 50px;
            }
            .el-menu-item:focus, .el-menu-item:hover {
                outline: 0;
                background-color: #F5F6FA;
            }
            .el-menu-item.is-active{
                background-color: #F5F6FA;
            }
            .nav_icon{
                margin-right: 10px;
            }
        }
    }
    .center_main{
        background-color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/personal.vue